// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrimljeneObavijesti_wrapper__h\\+unj,
.PrimljeneObavijesti_date__olIt0,
.PrimljeneObavijesti_topTitle__saztH {
  gap: 16px;
}
.PrimljeneObavijesti_wrapper__h\\+unj,
.PrimljeneObavijesti_notificationColumn__HFc4a,
.PrimljeneObavijesti_unreadColumn__S6waF {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.PrimljeneObavijesti_unreadColumn__S6waF {
  width: 100%;
}
.PrimljeneObavijesti_topTitle__saztH {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  color: #2e3646;
}
.PrimljeneObavijesti_emptySpan__omEhg {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}
.PrimljeneObavijesti_topTitle__saztH,
.PrimljeneObavijesti_emptySpan__omEhg {
  font-family: Inter;
  text-align: left;
}
.PrimljeneObavijesti_wrapper__h\\+unj,
.PrimljeneObavijesti_horizontal__xmh6i,
.PrimljeneObavijesti_notificationColumn__HFc4a,
.PrimljeneObavijesti_readColumn__L-HFc,
.PrimljeneObavijesti_topTitle__saztH,
.PrimljeneObavijesti_emptyContainer__b0e3Q {
  width: 100%;
}
.PrimljeneObavijesti_topTitle__saztH,
.PrimljeneObavijesti_readColumn__L-HFc,
.PrimljeneObavijesti_date__olIt0,
.PrimljeneObavijesti_moreButton__4lJff {
  display: flex;
  align-items: center;
  justify-content: center;
}
.PrimljeneObavijesti_horizontal__xmh6i {
  border: 1px solid #e2e2e2;
}
.PrimljeneObavijesti_moreButton__4lJff {
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  column-gap: 8px;
  cursor: pointer;
  height: 52px;
  padding-left: 20px;
  color: #5f6d7e;
  padding-right: 20px;
  flex-direction: row-reverse;
}
.PrimljeneObavijesti_dropdownItem__Mdp4n {
  cursor: pointer;
  display: flex;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
}
.PrimljeneObavijesti_dropdownItemDisabled__EPftc {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.7;
  display: flex;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
}
.PrimljeneObavijesti_dropdownItem__Mdp4n:hover {
  background-color: #f2f2f2;
}
.PrimljeneObavijesti_dropdownWrapper__bcF7Y {
  position: relative;
  display: inline-block;
}

.PrimljeneObavijesti_dropdownContainer__Sbf77 {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 17px 0px rgba(95, 109, 126, 0.16);
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 8px 0px;
  width: 200px;
  z-index: 999;
}

.PrimljeneObavijesti_moreButton__4lJff:hover {
  background-color: #d8d9da;
  transition: 300ms ease-in-out background-color;
}
.PrimljeneObavijesti_moreButtonIcon__eodFf {
  stroke: #000000;
}
.PrimljeneObavijesti_btnRow__DNtYd,
.PrimljeneObavijesti_checkboxRow__38hVN {
  display: flex;
  align-items: center;
}
.PrimljeneObavijesti_btnRow__DNtYd {
  gap: 32px;
  width: 100%;
  padding-bottom: 32px;
  justify-content: space-between;
}
.PrimljeneObavijesti_checkboxRow__38hVN {
  gap: 38px;
  justify-content: flex-start;
  flex-direction: row-reverse;
}
.PrimljeneObavijesti_saveBtn__EfhsJ {
  background-color: #cb9c2d;
  border-radius: 4px;
  height: 52px;
  border: none;
  width: 212px;
  align-items: center;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
  display: flex;
  justify-content: center;
  color: #ffffff;
  font-family: "Inter";
  margin: 0px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.PrimljeneObavijesti_saveBtn__EfhsJ:hover {
  background-color: #b98d26;
}
.PrimljeneObavijesti_saveBtn__EfhsJ:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}
.PrimljeneObavijesti_notificationColumn__HFc4a,
.PrimljeneObavijesti_readColumn__L-HFc {
  font-family: Inter;
  color: #4d4d4d;
}
.PrimljeneObavijesti_readColumn__L-HFc {
  flex-direction: column;
  margin-top: 24px;
}
.PrimljeneObavijesti_date__olIt0 {
  text-transform: uppercase;
  width: 20%;
}
.PrimljeneObavijesti_emptyContainer__b0e3Q {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 32px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  background-color: #fcfcfc;
  box-sizing: border-box;
}

.PrimljeneObavijesti_customCheckbox__nrU7r {
  border: 2px solid #a3a1a1;
  background-color: white;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  transition: all 200ms ease-in-out;
}
.PrimljeneObavijesti_customCheckbox__nrU7r:hover {
  box-shadow: 0px 0px 6px 0px rgba(149, 153, 158, 0.7);
}
.PrimljeneObavijesti_customCheckbox__nrU7r:checked {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  border: 2px solid #cb9c2d;
}
.PrimljeneObavijesti_customCheckbox__nrU7r:checked::before {
  display: block;
  text-align: center;
  border: 2px solid #cb9c2d;
  font-weight: bold;
  font-size: 14px;
  color: white;
}
.PrimljeneObavijesti_label__GRf4w {
  font-family: Inter;
  font-size: 16px;
  color: "#4D4E4E";
  font-weight: 600;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/PrimljeneObavijesti/PrimljeneObavijesti.module.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAS;AACX;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;;EAME,WAAW;AACb;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,oDAAoD;AACtD;AACA;EACE,2EAAwE;EACxE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".wrapper,\n.date,\n.topTitle {\n  gap: 16px;\n}\n.wrapper,\n.notificationColumn,\n.unreadColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.unreadColumn {\n  width: 100%;\n}\n.topTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  color: #2e3646;\n}\n.emptySpan {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n.topTitle,\n.emptySpan {\n  font-family: Inter;\n  text-align: left;\n}\n.wrapper,\n.horizontal,\n.notificationColumn,\n.readColumn,\n.topTitle,\n.emptyContainer {\n  width: 100%;\n}\n.topTitle,\n.readColumn,\n.date,\n.moreButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.horizontal {\n  border: 1px solid #e2e2e2;\n}\n.moreButton {\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  column-gap: 8px;\n  cursor: pointer;\n  height: 52px;\n  padding-left: 20px;\n  color: #5f6d7e;\n  padding-right: 20px;\n  flex-direction: row-reverse;\n}\n.dropdownItem {\n  cursor: pointer;\n  display: flex;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n}\n.dropdownItemDisabled {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.7;\n  display: flex;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n}\n.dropdownItem:hover {\n  background-color: #f2f2f2;\n}\n.dropdownWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdownContainer {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 4px 17px 0px rgba(95, 109, 126, 0.16);\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n  padding: 8px 0px;\n  width: 200px;\n  z-index: 999;\n}\n\n.moreButton:hover {\n  background-color: #d8d9da;\n  transition: 300ms ease-in-out background-color;\n}\n.moreButtonIcon {\n  stroke: #000000;\n}\n.btnRow,\n.checkboxRow {\n  display: flex;\n  align-items: center;\n}\n.btnRow {\n  gap: 32px;\n  width: 100%;\n  padding-bottom: 32px;\n  justify-content: space-between;\n}\n.checkboxRow {\n  gap: 38px;\n  justify-content: flex-start;\n  flex-direction: row-reverse;\n}\n.saveBtn {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  height: 52px;\n  border: none;\n  width: 212px;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n  display: flex;\n  justify-content: center;\n  color: #ffffff;\n  font-family: \"Inter\";\n  margin: 0px;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.saveBtn:hover {\n  background-color: #b98d26;\n}\n.saveBtn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.notificationColumn,\n.readColumn {\n  font-family: Inter;\n  color: #4d4d4d;\n}\n.readColumn {\n  flex-direction: column;\n  margin-top: 24px;\n}\n.date {\n  text-transform: uppercase;\n  width: 20%;\n}\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 32px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  background-color: #fcfcfc;\n  box-sizing: border-box;\n}\n\n.customCheckbox {\n  border: 2px solid #a3a1a1;\n  background-color: white;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 22px;\n  height: 20px;\n  border-radius: 4px;\n  outline: none;\n  cursor: pointer;\n  vertical-align: middle;\n  transition: all 200ms ease-in-out;\n}\n.customCheckbox:hover {\n  box-shadow: 0px 0px 6px 0px rgba(149, 153, 158, 0.7);\n}\n.customCheckbox:checked {\n  background: url(\"../../assets/img/Checkbox.png\") center center no-repeat;\n  border: 2px solid #cb9c2d;\n}\n.customCheckbox:checked::before {\n  display: block;\n  text-align: center;\n  border: 2px solid #cb9c2d;\n  font-weight: bold;\n  font-size: 14px;\n  color: white;\n}\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  color: \"#4D4E4E\";\n  font-weight: 600;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PrimljeneObavijesti_wrapper__h+unj`,
	"date": `PrimljeneObavijesti_date__olIt0`,
	"topTitle": `PrimljeneObavijesti_topTitle__saztH`,
	"notificationColumn": `PrimljeneObavijesti_notificationColumn__HFc4a`,
	"unreadColumn": `PrimljeneObavijesti_unreadColumn__S6waF`,
	"emptySpan": `PrimljeneObavijesti_emptySpan__omEhg`,
	"horizontal": `PrimljeneObavijesti_horizontal__xmh6i`,
	"readColumn": `PrimljeneObavijesti_readColumn__L-HFc`,
	"emptyContainer": `PrimljeneObavijesti_emptyContainer__b0e3Q`,
	"moreButton": `PrimljeneObavijesti_moreButton__4lJff`,
	"dropdownItem": `PrimljeneObavijesti_dropdownItem__Mdp4n`,
	"dropdownItemDisabled": `PrimljeneObavijesti_dropdownItemDisabled__EPftc`,
	"dropdownWrapper": `PrimljeneObavijesti_dropdownWrapper__bcF7Y`,
	"dropdownContainer": `PrimljeneObavijesti_dropdownContainer__Sbf77`,
	"moreButtonIcon": `PrimljeneObavijesti_moreButtonIcon__eodFf`,
	"btnRow": `PrimljeneObavijesti_btnRow__DNtYd`,
	"checkboxRow": `PrimljeneObavijesti_checkboxRow__38hVN`,
	"saveBtn": `PrimljeneObavijesti_saveBtn__EfhsJ`,
	"customCheckbox": `PrimljeneObavijesti_customCheckbox__nrU7r`,
	"label": `PrimljeneObavijesti_label__GRf4w`
};
export default ___CSS_LOADER_EXPORT___;
